// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.num-destac[data-v-9f36962c] {\n  font-weight: 600;\n  font-size: 24px;\n}\n.card[data-v-9f36962c] {\n  border-radius: 10px;\n  font-size: 22px;\n  width: 100%;\n  height: 100vh;\n  color: #697b8e;\n  border: 1px solid var(--stroke-);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
